/*
Copyright 2026 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import CurrentUserAccount from '@/components/controllers/current_user/CurrentUserAccount';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/account/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div className="flex flex-col grow">
    <CurrentUserAccount />
  </div>
}
